var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"flex-lg-nowrap"},[_c('b-col',{attrs:{"cols":"12","lg":"8","offset-lg":"2"}},[_vm._t("default")],2),_c('b-col',{staticClass:"pl-lg-0 sticky",attrs:{"cols":"12","lg":"2"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }